import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators
} from "reactstrap";
import { connect } from "react-redux";
import KickCarouselItemContent from "./kickCarousel/KickCarouselItemContent";
import { getCacheImage } from "../../config";
import { getCloudImageUrl } from "../../utils/Helpers";

class KickCarousel extends Component {
  constructor(props) {
    super(props);
    // this.state = { activeIndex: 0 };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating || this.props.pause) return;
    const nextIndex =
      this.props.activeIndex === this.props.sliders.length - 1
        ? 0
        : this.props.activeIndex + 1;
    this.props.onActiveIndexChanged(nextIndex);
  }

  previous() {
    if (this.animating || this.props.pause) return;
    const nextIndex =
      this.props.activeIndex === 0
        ? this.props.sliders.length - 1
        : this.props.activeIndex - 1;
    this.props.onActiveIndexChanged(nextIndex);
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.props.onActiveIndexChanged(newIndex);
  }

  _onRenderItems() {
    const { sliders, sliderState, dataAuth } = this.props;

    return sliders.map((item, index) => {
      const portaitImage =
        item.images.length > 0 &&
        item.images.find(data => data.orientation === "portrait");
      const mobileImageURL = portaitImage ? portaitImage.URL : item.img_url;

      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={`kick-hero-carousel--home__item-${index}`}
          className="kick-hero-carousel--home__item"
        >
          <div className="d-none d-sm-block">
            <KickCarouselItemContent
              id={item.id}
              src={getCloudImageUrl(item.img_url, 1500, "carousel")}
              altText={item.name}
              href={item.redirect_url}
              pageType={item.data ? item.data.type : null}
              isLink={true}
              dataAuth={dataAuth}
              history={this.props.history}
              onSliderClick={this.props.onSliderClick}
            />
          </div>
          <div className="d-block d-sm-none">
            <KickCarouselItemContent
              id={item.id}
              src={getCloudImageUrl(mobileImageURL, 1500, "carousel")}
              altText={item.name}
              href={item.redirect_url}
              pageType={item.data ? item.data.type : null}
              isLink={true}
              dataAuth={dataAuth}
              history={this.props.history}
              onSliderClick={this.props.onSliderClick}
            />
          </div>
        </CarouselItem>
      );
    });
  }

  render() {
    const { sliders, sliderState, activeIndex, dataCategory } = this.props;

    return (
      <Carousel
        activeIndex={activeIndex}
        next={this.next}
        previous={this.previous}
        className={`kick-hero-carousel--home ${this.props.countdown_modal ? "kick-hero-carousel--home-responsive" : ""}`}
      >
        {this._onRenderItems()}
        {
          dataCategory && (
            <>
              <CarouselControl
                className="kick-hero-carousel--home__control"
                direction="prev"
                directionText="Previous"
                onClickHandler={this.previous}
              />
              <CarouselControl
                className="kick-hero-carousel--home__control"
                direction="next"
                directionText="Next"
                onClickHandler={this.next}
              />
            </>
          )
        }
      </Carousel>
    );
  }
}

KickCarousel.defaultProps = {
  activeIndex: 0,
  autoPlay: false,
  pause: false
};

const mapStateToProps = (state) => ({
  countdown_modal: state.dataMenu.countdown_modal,
  dataCategory: state.dataCategory.selected
});

export default connect(mapStateToProps, null)(KickCarousel)
